import React from "react";
import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";

const FriendReferralsScreenContent = ({
  userObj,
  success,
  Error,
  referralEmail,
  setreferralEmail,
  seterror,
  error,
  handleReferAFriend,
  loader
}) => (
  <div className="flex-1 flex justify-center items-start bg-transparent">
    <div className="w-full max-w-4xl rounded-2xl pb-8 md:pb-10 md:px-10">
      <div className="text-2xl font-bold mb-8 text-gray-900 tracking-tight">Friend referrals</div>
      <div className="mb-4 text-sm text-gray-700">
        {userObj?.credit && <p className="mb-1">You have earned <span className="font-semibold text-green-700">${userObj?.credit}</span> so far.</p>}
        Invite your friends to order through wemoovez, using your unique link, and you will each receive a $5 credit when they place their first order.
        <p className="text-green-600 font-semibold mt-2">{success ? success : ""}</p>
        <p className="text-red-600 font-semibold mt-1">{Error ? Error : ""}</p>
      </div>
      <div className="mb-3">
        <div className="text-xs font-semibold text-gray-600 mb-1">Referral Email</div>
        <div className="flex items-center bg-[#F6F6FD] rounded-lg px-3 py-2 border border-gray-200">
          <input
            placeholder="Email for referral"
            value={referralEmail}
            onChange={(e) => { setreferralEmail(e.target.value); seterror(""); }}
            className="bg-transparent outline-none w-full text-gray-900 font-medium flex-1"
          />
        </div>
      </div>
      <div className="text-red-600 text-xs mb-2">{error ? error : ""}</div>
      <div className="flex flex-col md:flex-row gap-3 md:gap-4 mt-2">
        <button
          onClick={handleReferAFriend}
          className="flex-1 bg-[#211F59] hover:bg-[#18164a] text-white px-4 py-2.5 rounded-lg font-semibold shadow-sm transition"
        >
          Refer a friend
        </button>
      </div>
      {loader ? (
        <div className="text-center pt-4">
          <Box>
            <CircularProgress color="secondary" />
          </Box>
        </div>
      ) : null}
    </div>
  </div>
);

export default FriendReferralsScreenContent;
